module.exports = __webpack_public_path__ + "assets/24b93edc8d8355ae6a9d667c8415dc91.png";